import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from '~/style/colors-ts';

export const drawerOverrides: Components<Theme>['MuiDrawer'] = {
    styleOverrides: {
        paper: {
            backgroundColor: COLORS.white[900],
        },
    },
};
